<template>
    <div class="col-12 px-0 my-4 font-body font-size-16 font-weight-default text-primary-black">
        <div class="px-0">
            <h3 class="mb-2">
                <span class="title-4 text-grey-800">{{ stepNum }}{{ store.state.content.planner_chooseFormula }}</span>
            </h3>

            <div class="search-main px-lg-3 d-flex flex-column my-4">
                <template v-if="screenType === 'mobile'">
                    <Packages :packagesToDisplay="packagesToDisplay" />
                    <FlightOriginDropdown class="px-3" v-if="showMobileOriginDropdown" />
                    <Form class="mt-3" />
                </template>
                <template v-else>
                    <GeneralForm/>
                </template>
                <div class="d-flex w-100 px-3 pb-3">
                    <div v-if="store.getters.prestations[0]" class="col-12 px-0 ox-md-3">
                        <Banners :lihe="store.state.liheData"
                            :startDate="store.getters.prestations[0].variants[0].startDate" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, ComputedRef, watch } from "vue"
//import store from "@/vue/planning/store/store"

// components
import Form from "@/vue/planning/components/search/form.vue"; /// OLD way to search in the APP, after the new search block is implemented, delete this one and the legacy code
import Banners from "@/vue/planning/components/common/banners.vue";
import Packages from "@/vue/planning/components/search/packages.vue";
import FlightOriginDropdown from '@/vue/planning/components/search/flight/flightOriginDropDown.vue';
import GeneralForm from "@/vue/planning/components/search/generalForm.vue"
// config

// computed
import availableFlightPackCodes from "@/vue/planning/computed/availableFlightPackCodes"
import hasTransportOptions from "@/vue/planning/computed/hasTransportOptions"

import screenType from "@/vue/planning/computed/screenType"
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"

import { useStore } from "@/vue/planning/store/store";

const store = useStore();

// computed
const stepNum: ComputedRef<string> = computed(()=>{
    if (hasTransportOptions.value && store.state.screenType === "desktop") return "2. "
    return "1. "
})

const showMobileOriginDropdown = computed(() => availableFlightPackCodes.value.length > 0)


watch(
    () => store.getters.variants,
    () => store.dispatch("ensurePrestationsPreselected")
)

</script>

<style scoped>
.popup-prestation-image-list.animate {
    transition: left 250ms ease-in-out, right 250ms ease-in-out;
}

.popup-prestation-image {
    width: auto;
    height: 100%;
}

.popup-prestation-slider-mobile .slide-btn,
.main-popup-img-controls {
    top: 50%;
    transform: translateY(-50%);
}

.main-popup-img-controls>img {
    width: 18px;
    height: 18px;
}

.main-popup-img-controls.left {
    left: 5px;
}

.main-popup-img-controls.right {
    right: 5px;
}

.slide-left {
    left: 10px;
}

.slide-right {
    right: 10px;
}

.bg-black--opacity-7 {
    background-color: rgba(0, 0, 0, 0.7);
}

.slide-count {
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
}

.selectionner-btn {
    cursor: pointer;
    transition: 0.15s;
}

body {
    font-feature-settings: "lnum" 1;
}

.hover-blue:hover,
#review-carousel-container .slide-btn:hover,
.prest-row-image>div:hover {
    box-shadow: 0px 0px 4px 0px var(--blue);
}

.plus-info-close:hover {
    box-shadow: 0px 0px 4px 0px var(--gray);
}

.star-icon {
    margin-right: 2px;
}

#sticky-summary {
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    z-index: 1000;
}

.search-main {
    border-radius: var(--border-radius-secondary);
    max-width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    position: relative;
    list-style: none;
    background-color: #fff;
    box-shadow: 0px 0px 15px 0px #0d131b1a;
}

.switch {
    position: relative;
    display: inline-block;
    width: 42px;
    height: 23px;
}

.switch input {
    display: none;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked+.slider {
    background-color: var(--blue-600);
}

input:focus+.slider {
    box-shadow: 0 0 1px var(--blue-600);
}

input:checked+.slider:before {
    -webkit-transform: translateX(17px);
    -ms-transform: translateX(17px);
    transform: translateX(17px);
}

.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
